/* tslint:disable */
import {
  TemplateHeader
} from '../index';

declare var Object: any;
export interface ChangeSOPConfiguratorDetailInterface {
  "sfdcId"?: string;
  "Name"?: string;
  "CurrencyIsoCode"?: string;
  "CreatedById"?: string;
  "LastModifiedById"?: string;
  "CreatedBy__c"?: string;
  "LastModifiedBy__c"?: string;
  "Change_Board_Approval_Note__c"?: string;
  "Change_Board_Approval_Status__c"?: string;
  "Change_Board_Approved_By__c"?: string;
  "Change_Board_Approved_Date__c"?: Date;
  "Change_Impact_Type__c"?: string;
  "Change_SOP_Code__c"?: string;
  "Change_SOP_Configurator_Header__c"?: string;
  "Change_SOP_Detail_Number__c"?: string;
  "Change_SOP_Notes__c"?: string;
  "Change_SOP_Stage__c"?: string;
  "Change_SOP_Status__c"?: string;
  "Configurator_Detail_No__c"?: string;
  "Created_By_Contact__c"?: string;
  "Department_Change_Board__c"?: string;
  "Group_RASCI_A__c"?: string;
  "Group_RASCI_C__c"?: string;
  "Group_RASCI_I__c"?: string;
  "Group_RASCI_R__c"?: string;
  "Group_RASCI_S__c"?: string;
  "Header_Type__c"?: string;
  "Internal_Approval_Status__c"?: string;
  "Internal_Approved_By__c"?: string;
  "Internal_Approved_Date__c"?: Date;
  "Internal_Group_Department__c"?: string;
  "Internal_Team__c"?: string;
  "Last_Modified_By_Contact__c"?: string;
  "SOP_CAPA_Step_No__c"?: number;
  "SOP_Formatted_CAPA_No__c"?: string;
  "Step_Applies_to__c"?: string;
  "Step_Name_External__c"?: string;
  "Change_SOP_Step__c"?: string;
  "Team_Change_Board__c"?: string;
  "Team_RASCI_A__c"?: string;
  "Team_RASCI_A_Approval_Note__c"?: string;
  "Team_RASCI_A_Approval_Status__c"?: string;
  "Team_RASCI_A_Approved_By__c"?: string;
  "Team_RASCI_A_Approved_Date__c"?: Date;
  "Team_RASCI_C__c"?: string;
  "Team_RASCI_I__c"?: string;
  "Team_RASCI_R__c"?: string;
  "Team_RASCI_R_Approval_Note__c"?: string;
  "Team_RASCI_R_Approval_Status__c"?: string;
  "Team_RASCI_R_Approved_By__c"?: string;
  "Team_RASCI_R_Approved_Date__c"?: Date;
  "Team_RASCI_S__c"?: string;
  "Type__c"?: string;
  "Weightage__c"?: number;
  "id"?: number;
  "PgMO_Template_Header__c"?: string;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  templateHeader?: TemplateHeader;
}

export class ChangeSOPConfiguratorDetail implements ChangeSOPConfiguratorDetailInterface {
  "sfdcId": string;
  "Name": string;
  "CurrencyIsoCode": string;
  "CreatedById": string;
  "LastModifiedById": string;
  "CreatedBy__c": string;
  "LastModifiedBy__c": string;
  "Change_Board_Approval_Note__c": string;
  "Change_Board_Approval_Status__c": string;
  "Change_Board_Approved_By__c": string;
  "Change_Board_Approved_Date__c": Date;
  "Change_Impact_Type__c": string;
  "Change_SOP_Code__c": string;
  "Change_SOP_Configurator_Header__c": string;
  "Change_SOP_Detail_Number__c": string;
  "Change_SOP_Notes__c": string;
  "Change_SOP_Stage__c": string;
  "Change_SOP_Status__c": string;
  "Configurator_Detail_No__c": string;
  "Created_By_Contact__c": string;
  "Department_Change_Board__c": string;
  "Group_RASCI_A__c": string;
  "Group_RASCI_C__c": string;
  "Group_RASCI_I__c": string;
  "Group_RASCI_R__c": string;
  "Group_RASCI_S__c": string;
  "Header_Type__c": string;
  "Internal_Approval_Status__c": string;
  "Internal_Approved_By__c": string;
  "Internal_Approved_Date__c": Date;
  "Internal_Group_Department__c": string;
  "Internal_Team__c": string;
  "Last_Modified_By_Contact__c": string;
  "SOP_CAPA_Step_No__c": number;
  "SOP_Formatted_CAPA_No__c": string;
  "Step_Applies_to__c": string;
  "Step_Name_External__c": string;
  "Change_SOP_Step__c": string;
  "Team_Change_Board__c": string;
  "Team_RASCI_A__c": string;
  "Team_RASCI_A_Approval_Note__c": string;
  "Team_RASCI_A_Approval_Status__c": string;
  "Team_RASCI_A_Approved_By__c": string;
  "Team_RASCI_A_Approved_Date__c": Date;
  "Team_RASCI_C__c": string;
  "Team_RASCI_I__c": string;
  "Team_RASCI_R__c": string;
  "Team_RASCI_R_Approval_Note__c": string;
  "Team_RASCI_R_Approval_Status__c": string;
  "Team_RASCI_R_Approved_By__c": string;
  "Team_RASCI_R_Approved_Date__c": Date;
  "Team_RASCI_S__c": string;
  "Type__c": string;
  "Weightage__c": number;
  "id": number;
  "PgMO_Template_Header__c": string;
  "createdAt": Date;
  "updatedAt": Date;
  templateHeader: TemplateHeader;
  constructor(data?: ChangeSOPConfiguratorDetailInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ChangeSOPConfiguratorDetail`.
   */
  public static getModelName() {
    return "ChangeSOPConfiguratorDetail";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ChangeSOPConfiguratorDetail for dynamic purposes.
  **/
  public static factory(data: ChangeSOPConfiguratorDetailInterface): ChangeSOPConfiguratorDetail{
    return new ChangeSOPConfiguratorDetail(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ChangeSOPConfiguratorDetail',
      plural: 'ChangeSOPConfiguratorDetails',
      path: 'ChangeSOPConfiguratorDetails',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "CreatedBy__c": {
          name: 'CreatedBy__c',
          type: 'string'
        },
        "LastModifiedBy__c": {
          name: 'LastModifiedBy__c',
          type: 'string'
        },
        "Change_Board_Approval_Note__c": {
          name: 'Change_Board_Approval_Note__c',
          type: 'string'
        },
        "Change_Board_Approval_Status__c": {
          name: 'Change_Board_Approval_Status__c',
          type: 'string'
        },
        "Change_Board_Approved_By__c": {
          name: 'Change_Board_Approved_By__c',
          type: 'string'
        },
        "Change_Board_Approved_Date__c": {
          name: 'Change_Board_Approved_Date__c',
          type: 'Date'
        },
        "Change_Impact_Type__c": {
          name: 'Change_Impact_Type__c',
          type: 'string'
        },
        "Change_SOP_Code__c": {
          name: 'Change_SOP_Code__c',
          type: 'string'
        },
        "Change_SOP_Configurator_Header__c": {
          name: 'Change_SOP_Configurator_Header__c',
          type: 'string'
        },
        "Change_SOP_Detail_Number__c": {
          name: 'Change_SOP_Detail_Number__c',
          type: 'string'
        },
        "Change_SOP_Notes__c": {
          name: 'Change_SOP_Notes__c',
          type: 'string'
        },
        "Change_SOP_Stage__c": {
          name: 'Change_SOP_Stage__c',
          type: 'string'
        },
        "Change_SOP_Status__c": {
          name: 'Change_SOP_Status__c',
          type: 'string'
        },
        "Configurator_Detail_No__c": {
          name: 'Configurator_Detail_No__c',
          type: 'string'
        },
        "Created_By_Contact__c": {
          name: 'Created_By_Contact__c',
          type: 'string'
        },
        "Department_Change_Board__c": {
          name: 'Department_Change_Board__c',
          type: 'string'
        },
        "Group_RASCI_A__c": {
          name: 'Group_RASCI_A__c',
          type: 'string'
        },
        "Group_RASCI_C__c": {
          name: 'Group_RASCI_C__c',
          type: 'string'
        },
        "Group_RASCI_I__c": {
          name: 'Group_RASCI_I__c',
          type: 'string'
        },
        "Group_RASCI_R__c": {
          name: 'Group_RASCI_R__c',
          type: 'string'
        },
        "Group_RASCI_S__c": {
          name: 'Group_RASCI_S__c',
          type: 'string'
        },
        "Header_Type__c": {
          name: 'Header_Type__c',
          type: 'string'
        },
        "Internal_Approval_Status__c": {
          name: 'Internal_Approval_Status__c',
          type: 'string'
        },
        "Internal_Approved_By__c": {
          name: 'Internal_Approved_By__c',
          type: 'string'
        },
        "Internal_Approved_Date__c": {
          name: 'Internal_Approved_Date__c',
          type: 'Date'
        },
        "Internal_Group_Department__c": {
          name: 'Internal_Group_Department__c',
          type: 'string'
        },
        "Internal_Team__c": {
          name: 'Internal_Team__c',
          type: 'string'
        },
        "Last_Modified_By_Contact__c": {
          name: 'Last_Modified_By_Contact__c',
          type: 'string'
        },
        "SOP_CAPA_Step_No__c": {
          name: 'SOP_CAPA_Step_No__c',
          type: 'number'
        },
        "SOP_Formatted_CAPA_No__c": {
          name: 'SOP_Formatted_CAPA_No__c',
          type: 'string'
        },
        "Step_Applies_to__c": {
          name: 'Step_Applies_to__c',
          type: 'string'
        },
        "Step_Name_External__c": {
          name: 'Step_Name_External__c',
          type: 'string'
        },
        "Change_SOP_Step__c": {
          name: 'Change_SOP_Step__c',
          type: 'string'
        },
        "Team_Change_Board__c": {
          name: 'Team_Change_Board__c',
          type: 'string'
        },
        "Team_RASCI_A__c": {
          name: 'Team_RASCI_A__c',
          type: 'string'
        },
        "Team_RASCI_A_Approval_Note__c": {
          name: 'Team_RASCI_A_Approval_Note__c',
          type: 'string'
        },
        "Team_RASCI_A_Approval_Status__c": {
          name: 'Team_RASCI_A_Approval_Status__c',
          type: 'string'
        },
        "Team_RASCI_A_Approved_By__c": {
          name: 'Team_RASCI_A_Approved_By__c',
          type: 'string'
        },
        "Team_RASCI_A_Approved_Date__c": {
          name: 'Team_RASCI_A_Approved_Date__c',
          type: 'Date'
        },
        "Team_RASCI_C__c": {
          name: 'Team_RASCI_C__c',
          type: 'string'
        },
        "Team_RASCI_I__c": {
          name: 'Team_RASCI_I__c',
          type: 'string'
        },
        "Team_RASCI_R__c": {
          name: 'Team_RASCI_R__c',
          type: 'string'
        },
        "Team_RASCI_R_Approval_Note__c": {
          name: 'Team_RASCI_R_Approval_Note__c',
          type: 'string'
        },
        "Team_RASCI_R_Approval_Status__c": {
          name: 'Team_RASCI_R_Approval_Status__c',
          type: 'string'
        },
        "Team_RASCI_R_Approved_By__c": {
          name: 'Team_RASCI_R_Approved_By__c',
          type: 'string'
        },
        "Team_RASCI_R_Approved_Date__c": {
          name: 'Team_RASCI_R_Approved_Date__c',
          type: 'Date'
        },
        "Team_RASCI_S__c": {
          name: 'Team_RASCI_S__c',
          type: 'string'
        },
        "Type__c": {
          name: 'Type__c',
          type: 'string'
        },
        "Weightage__c": {
          name: 'Weightage__c',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "PgMO_Template_Header__c": {
          name: 'PgMO_Template_Header__c',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        templateHeader: {
          name: 'templateHeader',
          type: 'TemplateHeader',
          model: 'TemplateHeader',
          relationType: 'belongsTo',
                  keyFrom: 'PgMO_Template_Header__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
